import React, { Fragment, useEffect, useState } from 'react';
import { useRedirect, useTranslate, useResourceContext, useResourceDefinitions, ListContextProvider, ListToolbar, useList, DateField, useRemoveFromStore, useNotify } from 'react-admin';
import { useParams } from 'react-router-dom';
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Divider, Link, TextField, Button, Box, Grid, Icon, Container, InputLabel, FormControl, MenuItem, Select, Tooltip } from '@mui/material';
import PageDividerText from 'src/components/customComponents/B2/PageDividerText';
import BillingFormEditDialogPayments from 'src/components/pages/payment/billing-form/billingFormEditDialogPayments';
import BillingFormEditDialogReservations from 'src/components/pages/payment/billing-form/BillingFormEditDialogReservations';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { hasPermissionFunction } from 'src/helper/HasPermission';
import { PERMISSION_EDIT } from 'src/helper/Permission';
import { LoadingButton } from '@mui/lab';

function BillingFormEdit(props) {
	const translate = useTranslate()
	const redirect = useRedirect();
	const propsResource = useResourceDefinitions();
	const resourceName = useResourceContext();
	const notify = useNotify();
	const { id } = useParams();
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [openDialogPayment, setOpenDialogPayment] = React.useState(false);
	const [editLoading, setEditLoading] = useState(false)

	// Inputs
	const [dataInputs, setDataInputs] = useState({});

	// Start
	const getBillingFormList = async (id) => {
		setIsLoading(true);
		try {
			let query = "id=" + id;
			const billingList = await billingFormServices.getBillingFormList(query);
			setData(billingList.billingforms[0]);
			setDataInputs(billingList.billingforms[0]);
		} catch (error) {
			console.error('Error fetching billing forms: ', error);
			setData([]);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getBillingFormList(id);
	}, []);

	const onChangeField = (field, value) => {
		setDataInputs((prevFilters) => ({
			...prevFilters,
			[field]: value,
		}));
	};

	// Start Dialog Payment
	const handleOpenDialogPayment = () => {
		setOpenDialogPayment(true);
	};
	const handleCloseDialogPayment = () => {
		setOpenDialogPayment(false);
	};
	// End Dialog Payment

	const handleEditMode = () => {
		if (hasPermissionFunction('billingform', 'edit')) {
			setEditMode(true);
		}
	};

	const handleBtnSalir = () => {
		redirect('list', 'billingform');
	};

	// Submit Edit
	const handleClickSaveEdit = async () => {
		const billingFormId = id;
		const dataToUpdate = {
			status: dataInputs.status,
			observation_internal: dataInputs.observation_internal,
		};
		setEditLoading(true)
		await billingFormServices.editCurrencyBaseRelation(billingFormId, dataToUpdate).then(()=>{
			notify('Formulario de facturación actualizado exitosamente', { type: 'success' });
			redirect('list', 'billingform');
		})
		.catch((error)=>{
			notify('Error al actualizar el formulario de facturación', { type: 'error' });
			console.error('Error al actualizar el formulario de facturación: ', error);
		})
		.finally(()=>{
			setEditLoading(false)
		})
		
	};

	return (
		<Container className='pageListContainer generalFormStyles'>
			<Grid container spacing={3} className='pageListCard'>
				<Grid item xs={12} md={4} lg={4} xl={3} >
					<FormControl fullWidth variant='outlined' size='small'>
						<InputLabel>{translate('ra.field.status')}</InputLabel>
						<Select
							id="dataFormStatus"
							label="Estado"
							value={dataInputs?.status || ''}
							onChange={(e) => onChangeField('status', e.target.value)}
							disabled={!editMode || dataInputs?.available_status === null}
						>
							<MenuItem key={1} value={'ingresado'}
								disabled={data?.status !== 'ingresado' && dataInputs?.available_status !== 'ingresado'}
								style={data?.status === 'ingresado' ? { color: '#5563CD' } : {}}>
								{translate('ra.status.status_entered')}
							</MenuItem>
							<MenuItem key={2} value={'en revision'}
								disabled={data?.status !== 'en revision' && dataInputs?.available_status !== 'en revision'}
								style={data?.status === 'en revision' ? { color: '#5563CD' } : {}}>
								{translate('ra.status.status_review')}
							</MenuItem>
							<MenuItem key={2} value={'rechazado'}
								disabled={data?.status !== 'rechazado' && dataInputs?.available_status !== 'rechazado'}
								style={data?.status === 'rechazado' ? { color: '#5563CD' } : {}}>
								{translate('ra.status.status_rejected')}
							</MenuItem>
							<MenuItem key={2} value={'aprobado'}
								disabled={data?.status !== 'aprobado' && dataInputs?.available_status !== 'aprobado'}
								style={data?.status === 'aprobado' ? { color: '#5563CD' } : {}}>
								{translate('ra.status.status_aproved')}
							</MenuItem>
							<MenuItem key={2} value={'aprobado parcial'}
								disabled={data?.status !== 'aprobado parcial' && dataInputs?.available_status !== 'aprobado parcial'}
								style={data?.status === 'aprobado parcial' ? { color: '#5563CD' } : {}}>
								{translate('ra.status.status_aproved_partially')}
							</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={12} md={4} lg={4} xl={3} >
					<TextField
						size='small'
						fullWidth
						value={dayjs(dataInputs?.create_at).format('DD/MM/YYYY') || ''}
						label={translate('ra.field.created_at')}
						disabled={true}
					/>
				</Grid>

				<Grid item xs={12} md={12} lg={12} xl={12} >
					<PageDividerText content={translate('ra.field.user')} />
				</Grid>
				<Grid item xs={12} md={4} lg={4} xl={3} >
					<TextField
						size='small'
						fullWidth
						value={dataInputs?.user_info?.name || ''}
						label={translate('ra.field.firstname')}
						disabled={true}
					/>
				</Grid>
				<Grid item xs={12} md={4} lg={4} xl={3} >
					<TextField
						size='small'
						fullWidth
						value={dataInputs?.user_info?.surname || ''}
						label={translate('ra.field.surname')}
						disabled={true}
					/>
				</Grid>
				<Grid item xs={12} md={4} lg={4} xl={3} >
					<TextField
						size='small'
						fullWidth
						value={dataInputs?.user_info?.email || ''}
						label={translate('ra.field.mail')}
						disabled={true}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Grid container spacing={3}>
						<Grid item xs={12} md={4} lg={4} xl={3} >
							<TextField
								size='small'
								fullWidth
								value={dataInputs?.business_unit_info?.long_name || ''}
								label={translate('ra.field.business_unit')}
								disabled={true}
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Grid container spacing={3} >
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<PageDividerText content={translate('ra.field.payments')} />
						</Grid>
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<table className='tableInfoPayment tableInfo bordered'>
								<tr className='tableHead'>
									<td className='cell'>{translate('ra.field.id')}</td>
									<td className='cell'>{translate('ra.field.status')}</td>
									<td className='cell'>{translate('ra.field.payment_types')}</td>
									<td className='cell'>{translate('ra.field.amount')}</td>
									<td className='cell'>{translate('ra.field.payment_date')}</td>
									<td className='cell'></td>
								</tr>
								{dataInputs?.payments?.map((payment, index) => (
									<>
										<tr className='tableBody' style={{ borderTop: '1px solid #ddd' }}>
											<td className='cell bold'>{payment.id}</td>
											<td className='cell'>{payment.conciliation_result?.status ? payment.conciliation_result?.status : 'ingresado'}</td>
											<td className='cell'>{payment.payment_type}</td>
											<td className='cell celdaMontoSinRetencion'>
												{payment.currency_info.short_name} {' '}
												{new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(payment.amount))}</td>
											<td className='cell'>{payment.payment_date}</td>
											<td className='cellBtn'><BillingFormEditDialogPayments className='btn' payment={payment} /></td>
										</tr>
										{payment?.retentions &&
											payment.retentions.length > 0 &&
											payment.retentions.map((retention, retentionIndex) => (
												<tr className="tableBody" key={`${index}-retention-${retentionIndex}`} style={{ padding: '10px 0', borderBottom: retentionIndex === payment.retentions.length - 1 ? '1px solid #ddd' : 'none', }} >
													<td className="cell bold">  </td>
													<td className="cell">{retention.status}</td>
													<td className="cell">Retención {retention.type}</td>
													<td className="cell celdaMontoConRetencion">
														{payment.currency_info.short_name} {' '}
														{new Intl.NumberFormat('es-AR', {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(
															payment.currency_info.short_name === 'ARS'
																? parseFloat(retention.amount)
																: parseFloat(retention.amount) * parseFloat(payment.currency_info.retention_value)
														)}
														{payment.currency_info.short_name !== 'ARS' &&
															<Tooltip placement="bottom" arrow title={
																<>
																	Valor en ARS: $ {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(retention.amount))}
																	<br />
																	Tipo de cambio: {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(parseFloat(payment.currency_info.retention_value))}
																</>
															}>
																<InfoOutlinedIcon
																	fontSize="small"
																	sx={{
																		color: '#FF7F50',
																		marginLeft: '5px',
																		verticalAlign: 'text-bottom',
																		cursor: 'pointer',
																	}}
																/>
															</Tooltip>
														}
													</td>
													<td className="cell">{payment.payment_date}</td>
													<td className="cell"></td>
												</tr>
											))}
									</>
								))}
								<tr className='tableBody'>
									<td className='cell'></td>
									<td className='cell'></td>
									<td className='cell'></td>
									<td className="cell cellTotalInfo">
									{dataInputs?.payments?.[0]?.currency_info?.short_name}{' '}
										{(() => {
											// Sumamos los montos sin retención
											const totalSinRetencion = dataInputs?.payments?.reduce(
												(acc, payment) => acc + parseFloat(payment.amount || 0),
												0
											);

											// Sumamos los montos con retención
											const totalConRetencion = dataInputs?.payments?.reduce(
												(acc, payment) =>
													acc +
													(payment.retentions
														? payment.retentions.reduce((retAcc, retention) => {
															const retentionAmount =
																payment.currency_info.short_name === 'ARS'
																	? parseFloat(retention.amount || 0)
																	: parseFloat(retention.amount || 0) *
																	parseFloat(payment.currency_info.retention_value || 1);
															return retAcc + retentionAmount;
														}, 0)
														: 0),
												0
											);

											// Total general
											const totalGeneral = totalSinRetencion + totalConRetencion;

											// Formateamos el total
											return totalGeneral.toLocaleString('es-AR', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											});
										})()} {' (total)'}
									</td>
									<td className='cell'></td>
								</tr>
							</table>
							<div className="disclaimer" style={{fontSize: '0.85rem'}} >
								<i>*{translate('ra.message.disclaimer_billingform_all_amounts_are_expressed_value_selected_payment_currency_selected')}</i>
							</div>
							<div className="disclaimer" style={{fontSize: '0.85rem'}} >
								<i>**{translate('ra.title.exchange_type')}: {dataInputs?.ars_usd_exchange ? dataInputs?.ars_usd_exchange : 'No disponible'}</i>
							</div>
						</Grid>
						<Grid item xs={12} md={12} lg={12} xl={12}>

						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Grid container spacing={3} >
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<PageDividerText content={translate('ra.field.reservations')} />
						</Grid>
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<table className='tableInfo bordered ' >
								<tr className='tableHead'>
									<td className='cell'>{translate('ra.field.number')}</td>
									<td className='cell'>{translate('ra.field.total_reservation')}</td>
									<td className='cell'>{translate('ra.field.inputation_type')}</td>
									<td className='cell'>{translate('ra.field.amount_aboned')}</td>
									<td className='cell'></td>
								</tr>
								{dataInputs?.reservations_info?.map((reservation, index) => (
									<tr className='tableBody' style={{ borderTop: '1px solid #ddd' }}>
										<td className='cell bold'>{reservation.number}</td>
										<td className='cell'>{reservation.destination_prices.destination_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.destination_prices?.total_amount))}
										</td>
										<td className='cell'>{reservation?.reservation_payment?.type}</td>
										<td className='cell'>{reservation.destination_prices.destination_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation?.reservation_payment?.amount))}
										</td>
										<td className='cell'> <BillingFormEditDialogReservations className='btn' reservation={reservation} /></td>
									</tr>
								))}
								<tr className='tableBody' style={{borderTop: '1px solid rgb(221, 221, 221'}}>
									<td className='cell'></td>
									<td className='cell'></td>
									<td className='cell'></td>
									<td className='cell cellTotalInfo'> {dataInputs?.reservations_info?.[0]?.destination_prices?.destination_currency}{' '}
										{dataInputs?.reservations_info
											?.reduce((acc, reservation) => {
												const amount = parseFloat(reservation?.reservation_payment?.amount) || 0;
												return acc + amount;
											}, 0)
											.toLocaleString('es-AR', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										{' (total)'}
									</td>
									<td className='cell'></td>
								</tr>
							</table>
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Grid container spacing={3} >
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<PageDividerText content={translate('ra.field.observations')} />
						</Grid>
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<TextField
								multiline={true}
								rows={4}
								size='small'
								fullWidth
								value={dataInputs?.observation_internal || ''}
								label={translate('ra.field.observations_internal')}
								disabled={!editMode}
								onChange={(e) => onChangeField('observation_internal', e.target.value)}
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Divider></Divider>
				</Grid>
				<Grid item xs={12} md={12} lg={12} xl={12} >
					<Box display="flex" justifyContent="flex-end">
						<Button variant="outlined" startIcon={<Icon>transit_enterexit</Icon>} component={Link} onClick={handleBtnSalir} >
							{translate('ra.action.back_to_list')}
						</Button>
						{editMode &&
							<Fragment>
								<LoadingButton loading={editLoading} className='btnWarming' style={{ marginLeft: 15 }} variant="contained" startIcon={<Icon>save</Icon>} component={Link} onClick={() => handleClickSaveEdit()} >
									{translate('ra.action.save')}
								</LoadingButton>
							</Fragment>
						}
						{hasPermissionFunction('billingform', 'edit') && !editMode &&
							<Button style={{ marginLeft: 15 }} disabled={!hasPermissionFunction('billingform', PERMISSION_EDIT)} variant="contained" startIcon={<Icon>edit</Icon>} onClick={() => handleEditMode()} >
								{translate('ra.action.edit')}
							</Button>
						}
					</Box>
				</Grid>
			</Grid>

		</Container>
	)
}
export default BillingFormEdit